import type { StageSliderData } from '~/lib/promotions-type';

export const homepagePromotions: StageSliderData[] = [
  {
    startDate: '01.10.2026 00:00',
    endDate: '31.10.2026 23:59',
    background: {
      src: '/content/content-images/promotions/2026-autumn/4cd6183af50b872e5e85c2e27636db79/shop-telekom-startseite-herbst-09-2026-s@2x.png',

      srcSm:
        '/content/content-images/promotions/2026-autumn/6cbad8a8b1e7c6a48428e1b7506d2f68/shop-telekom-startseite-herbst-09-2026-m@2x.png',
      srcMd:
        '/content/content-images/promotions/2026-autumn/523a43b275654c03a0bdc3ddfd2dff77/shop-telekom-startseite-herbst-09-2026-l@2x.png',
      aspectRatio: '16 / 13',
      aspectRatioSm: '128 / 65',
      aspectRatioMd: '48 / 13',
      sizes: 'xs:150vw sm:100vw md:150vw lg:150vw',
    },
    headline: {
      text: 'Herbstzeit ist Schnäppchenzeit',
    },
    subline:
      'Entdecke Zubehör und Technik-Highlights für unterwegs und zuhause – jetzt zu attraktiven Aktionspreisen.',
    ctaButton: {
      tag: 'nuxt-link',
      label: 'Zu den Angeboten',
      to: '/newsletter',
      size: 'medium',
      variant: 'primary',
    },
  },
  {
    endDate: '13.11.2026 23:59',
    customClass: 'stage--komoot',
    background: {
      src: '/content/content-images/promotions/komoot/b68528c04322901fbc8a72ededf4c883/shop-telekom-kampagne-s@2x.png',
      srcSm:
        '/content/content-images/promotions/komoot/0ee469c7bea1c18475e38495acad2c6e/shop-telekom-kampagne-m@2x.png',
      srcMd:
        '/content/content-images/promotions/komoot/2ef1614ffe8915363110a3bc23e4c719/shop-telekom-kampagne-l@2x.png',
      aspectRatio: '16 / 13',
      aspectRatioSm: '128 / 65',
      aspectRatioMd: '48 / 13',
      sizes: 'xs:150vw sm:100vw md:150vw lg:150vw',
    },
    headline: {
      text: 'Happy Autumn.<br>Zeit, rauszugehen und was zu erleben.',
    },
    subline: '2 Wochen komoot Premium gratis, einfach per Handyrechnung.',
    ctaButton: {
      tag: 'nuxt-link',
      label: 'Jetzt Angebot entdecken',
      to: '/handyrechnung-partner/komoot',
      size: 'medium',
      variant: 'primary',
    },
    badge: {
      style: 'text--uppercase',
      text: '<span class="text--uppercase">2&nbsp;Wochen <span style="font-size: 1.3rem;">Gratis</span></span>',
      position: {
        mobile: {
          top: '10%',
          left: '60%',
        },
        default: {
          top: '30%',
          left: '65%',
        },
      },
    },
  },
  {
    customClass: 'stage--samsung-angebote',
    startDate: '14.11.2026',
    customStyle: [
      '--visual-width: 60%',
      '--visual-justify-sm: flex-end',
      '--slide-image-height-sm: 120%',
      '--slide-image-height-md: 140%',
    ].join('; '),
    background: {
      src: '/content/content-images/promotions/2026-samsung-angebote/4d1348fc2fdb14c4f48177038a3dfcfd/shop-telekom-startseite-fruehjahrsputz-03-2026-bg-s.png',
      srcSm:
        '/content/content-images/promotions/2026-samsung-angebote/09e858ae07e9cbade82c5eaf873e3db6/shop-telekom-startseite-samsungaktion-03-2026-bg-m.png',
      srcMd:
        '/content/content-images/promotions/2026-samsung-angebote/5d44b8f00ae7ac3102a2826ec003f5cb/shop-telekom-startseite-samsungaktion-03-2026-bg-l.png',
      alt: '',
      sizes: 'xs:120vw sm:100vw md:150vw lg:2560px',
      aspectRatio: '16 / 13',
      aspectRatioSm: '2048 / 1040',
      aspectRatioMd: '3840 / 1040',
    },
    headline: {
      brand: {
        slug: 'samsung',
        name: 'Samsung',
      },
      text: 'Neue Serie,<br/>neues Zubehör!',
    },
    subline: 'Jetzt zur neuen <strong>Galaxy S26 Serie</strong> passendes Zubehör sichern!',
    visual: {
      src: '/content/content-images/promotions/2026-samsung-angebote/3425cbf6c7c25acbd44346e930681536/shop-telekom-startseite-samsungaktion-03-2026-geraete-m-s.png',
      srcSm:
        '/content/content-images/promotions/2026-samsung-angebote/3425cbf6c7c25acbd44346e930681536/shop-telekom-startseite-samsungaktion-03-2026-geraete-m-s.png',
      srcMd:
        '/content/content-images/promotions/2026-samsung-angebote/c97b032ac57439963f27b8afd8fe0877/shop-telekom-startseite-samsungaktion-03-2026-geraete-l.png',
      aspectRatio: '395 / 511',
      aspectRatioSm: '395 / 511',
      aspectRatioMd: '599 / 654',
      alt: 'Samsung Galaxy S26 Zubehör: Galaxy Buds4 Pro, Clear Case und Magnet Case',
      sizes: 'xs:50vw sm:50vw md:60vw lg:800px',
      imageStyle: 'margin-top: 200px',
    },
    ctaButton: {
      tag: 'nuxt-link',
      label: 'Jetzt Angebote entdecken',
      to: '/zubehoer/_samsung?filters=samsung,s26&orFilters=buds4',
      variant: 'primary',
    },
  },
  {
    customClass: 'stage--anker',
    customStyle: [
      '--background-position-md: 40% bottom',
      '--visual-justify-sm: space-between',
      '--visual-width: 50%',
      '--background: #F7F7F7',
    ].join('; '),
    background: {
      src: '/content/content-images/promotions/anker-oct/12c5210c276df04ed2602362d2a6281f/shop-telekom-startseite-stage-apple-zubehoer-s-v2@2x.jpg',
      srcSm:
        '/content/content-images/promotions/anker-oct/2f7ca19dcc2b7f4f471684eb2a3f34b5/shop-telekom-startseite-stage-apple-zubehoer-m-v2@2x.jpg',
      srcMd:
        '/content/content-images/promotions/anker-oct/376ab106ce617b50a4a2bf6de09236f4/shop-telekom-startseite-stage-anker-l-v2@2x.jpg',
      sizes: 'xs:120vw sm:100vw md:150vw lg:2560px',
      aspectRatio: '1280 / 1024',
      aspectRatioSm: '2048 / 1040',
      aspectRatioMd: '3840 / 1040',
    },
    headline: {
      brand: {
        slug: 'anker',
        name: '',
      },
      text: 'Anker für iPhone',
    },
    subline:
      'Entdecke jetzt die effizienten und kompakten Schnelllader - optimiert für dein iPhone.',
    ctaButton: {
      tag: 'nuxt-link',
      label: 'Jetzt entdecken',
      variant: 'secondary',
      to: '/zubehoer/lader-kabel-adapter/_anker?notFilters=lightning',
    },
  },
];
